import React from 'react';
import PropTypes from 'prop-types';
import trackEvent from '../utils/trackEvent';
import { setClassNames } from '../utils/utility';

const AdChoices = ({ label, classes, windowId }) => {
	return (
		<a
			href="https://www.dealer.com/opt-out/"
			target="_blank"
			rel="noopener noreferrer"
			className={setClassNames(
				'adchoices',
				'text-black',
				'line-height-reset',
				'd-flex',
				'align-items-center',
				classes
			)}
			onClick={() => {
				trackEvent('Ad Choices', windowId);
			}}
		>
			{label}
			<img
				className="d-inline"
				width="11"
				height="11"
				aria-hidden
				alt=""
				src="https://images.dealer.com/ddc/adchoices/logo.svg"
			/>
		</a>
	);
};

AdChoices.propTypes = {
	label: PropTypes.string.isRequired,
	classes: PropTypes.string.isRequired,
	windowId: PropTypes.string.isRequired
};

export default AdChoices;
